import React from 'react'
import IconHome from "@/assets/icons/ico-home.svg?react"
import IconProducts from "@/assets/icons/ico-products.svg?react"
import IconAccessory from "@/assets/icons/ico-accessory.svg?react"
import IconDiy from "@/assets/icons/ico-diy.svg?react"
import IconCs from "@/assets/icons/ico-cs.svg?react"
import IconPayment from "@/assets/icons/ico-payment.svg?react"
import IconEquipment from "@/assets/icons/ico-equipment.svg?react"
import IconSpecialExhibition from "@/assets/icons/ico-special-exhibition.svg?react"
import IconCustomer from "@/assets/icons/ico-customer.svg?react"
import IconStore from "@/assets/icons/ico-store.svg?react"
import {
  ROUTE_ACCESSORIES_PARTS, ROUTE_ACCESSORIES_CONSUMABLES, ROUTE_DIY_PALETTE, ROUTE_DIY_PATTERN, ROUTE_DIY_STICKER,
  ROUTE_PRODUCTS_CLASSIFICATION,
  ROUTE_PRODUCTS_PIECES,
  ROUTE_PRODUCTS_SET,
  ROUTE_ORDER,
  // ROUTE_PAYMENT,
  ROUTE_EQUIPMENT_VENDING_MACHINE,
  ROUTE_SPECIAL_EXHIBITION, ROUTE_ACCESSORIES_NONSALES,
  ROUTE_CUSTOMER,
  ROUTE_STORE
} from "@/routes/const.ts";

interface MenuProps {
  id: string
  label: string
  path: string
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>
  active?: boolean;
  children?: MenuProps[]
}

export function getMenuList(): MenuProps[] {
  return [
    {
      id: 'home',
      label: '홈',
      path: '/',
      icon: IconHome,
    },
    {
      id: 'products',
      label: '디자인',
      path: '/products',
      icon: IconProducts,
      children: [
        {
          id: 'pieces',
          label: '피스',
          path: `${ROUTE_PRODUCTS_PIECES}`,
        },
        {
          id: 'set',
          label: '세트',
          path: `${ROUTE_PRODUCTS_SET}`,
        },
        {
          id: 'classification',
          label: '분류',
          path: `${ROUTE_PRODUCTS_CLASSIFICATION}`,
        }
      ]
    },
    {
      id: 'shop',
      label: '액세서리',
      path: '/accessory',
      icon: IconAccessory,
      children: [
        {
          id: 'parts',
          label: '파츠',
          path: `${ROUTE_ACCESSORIES_PARTS}`,
        },
        {
          id: 'consumables',
          label: '부자재',
          path: `${ROUTE_ACCESSORIES_CONSUMABLES}`,
        },
        {
          id: 'non-sales',
          label: '비매품',
          path: `${ROUTE_ACCESSORIES_NONSALES}`
        }
      ]
    },
    {
      id: 'diy',
      label: 'DIY',
      path: '/diy',
      icon: IconDiy,
      children: [
        {
          id: 'palette',
          label: '컬러 팔레트',
          path: `${ROUTE_DIY_PALETTE}`,
        },
        {
          id: 'pattern',
          label: '패턴',
          path: `${ROUTE_DIY_PATTERN}`,
        },
        {
          id: 'sticker',
          label: '스티커',
          path: `${ROUTE_DIY_STICKER}`,
        },
      ]
    },
    {
      id: 'customer',
      label: '고객',
      path: ROUTE_CUSTOMER,
      icon: IconCustomer,
    },
    {
      id: 'order',
      label: '주문',
      path: ROUTE_ORDER,
      icon: IconPayment,
    },
    // 결제: 이전에 쓰던 임시 페이지, 주문 페이지 개발 시 비활성화 
    // {
    //   id: 'payment',
    //   label: '결제',
    //   path: ROUTE_PAYMENT,
    //   icon: IconPayment,
    // },
    {
      id: 'cs',
      label: 'CS',
      path: '/cs',
      icon: IconCs,
      children: [
        {
          id: 'inquiry',
          label: '1:1 문의',
          path: 'https://nailtoctoc.atlassian.net/jira/servicedesk/projects/VHQA/queues/custom/1',
        },
        {
          id: 'chat',
          label: '채팅 상담',
          path: 'https://center-pf.kakao.com',
        },
      ]
    },
    {
      id: 'store',
      label: '매장',
      path: ROUTE_STORE,
      icon: IconStore
    },
    {
      id: 'equipment',
      label: '장비',
      path: '/equipment',
      icon: IconEquipment,
      children: [
        {
          id: 'vending-machine',
          label: '자판기',
          path: ROUTE_EQUIPMENT_VENDING_MACHINE,
        }
      ]
    },
    {
      id: 'special-exhibition',
      label: '기획전',
      path: ROUTE_SPECIAL_EXHIBITION,
      icon: IconSpecialExhibition,
    }
  ]
}
